import { SecureClient } from '../../../utils';

const sendOTPExistingCustomerAPICall = ({
  customerCredentials,
  payload,
  successFn,
  errorFn,
  finallyFn,
}) => {
  const { customerId, Authorization, customerRefNum } = customerCredentials;
  SecureClient({
    isEncrypted: true,
    customerId,
    otherPayloadDetailsPresent: true,
    route: 'esqa/sendotpexistingcustomer',
    headers: {
      Authorization,
    },
    payload,
    successFn,
    errorFn,
    finallyFn,
  });
};

export default sendOTPExistingCustomerAPICall;
